class MembresController {
  constructor() {

    var that = this;

    that.membres = [
      {
        nom: "Fangamar",
        prenom: "Bruno",
        statut: "Président"
      },
      {
        nom: "Fratini",
        prenom: "Hervé",
        statut: "Trésorier"
      },
      {
        nom: "Fratini",
        prenom: "Solène",
        statut: "Secrétaire"
      },
      {
        nom: "Pastor",
        prenom: "Sandrine",
        statut: "Membre du bureau"
      },
      {
        nom: "Fangamar",
        prenom: "Marie-Lourdes",
        statut: "Membre du bureau"
      },
      {
        nom: "Binoche-Farinacci",
        prenom: "Anne-Laure",
        statut: "Membre du bureau"
      },      
      {
        nom: "Petillon",
        prenom: "Jean-Loup",
        statut: "Membre du bureau"
      },
      {
        nom: "Petillon",
        prenom: "Sébastien",
        statut: "Membre du bureau"
      },
    ];

    that.abaim = [
      {
        nom: "Topsy",
        prenom: "Krishna",
        statut: "Président"
      },
      {
        nom: "Bouvéry",
        prenom: "Marousia",
        statut: "Responsable"
      }
    ];

    that.amis = [
      {
        nom: "Manassero",
        prenom: "Alain",
        statut: "Membre du bureau"
      },
      {
        nom: "Manassero",
        prenom: "Catherine",
        statut: "Membre du bureau"
      },
      {
        nom: "Petillon",
        prenom: "Jean-Luc",
        statut: ""
      },
      {
        nom: "Fangamar",
        prenom: "Marie-Thérèse",
        statut: ""
      },
      {
        nom: "Ciais",
        prenom: "Monique",
        statut: ""
      },
      {
        nom: "Fangamar",
        prenom: "Chantal",
        statut: ""
      },
      {
        nom: "Dupré",
        prenom: "Geneviève",
        statut: ""
      }
    ];

  }
}

MembresController.$inject = [];

module.exports = MembresController;



// WEBPACK FOOTER //
// ./src/app/components/membres/membres.controller.js